import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import StateHelplines from '../../../assets/StateHelplines.PNG'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '90%',
    flexShrink: 0,
    color: '#fff'
  },
  main:{
    marginBottom:'10px'
  },
  body:{
    backgroundColor: '#7986cb',
  },
  links:{
    backgroundColor: '#fff',
  },
}));

export default function LinkAccordian() {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div className={classes.root}>
      <Accordion expanded={expanded === 'panel1'} className={classes.main} onChange={handleChange('panel1')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          className={classes.body}
        >
          <Typography className={classes.heading}>Donate Plasma (Websites to refer)</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.links}>
          
          &rarr; &nbsp;<a href="https://dhoondh.com/" target='_blank' rel="noreferrer">Dhoond.com</a><br/>
          &rarr; &nbsp;<a href="http://plasmadonor.in/" target='_blank' rel="noreferrer">plasmadonor.in</a><br/>
          &rarr; &nbsp;<a href="http://needplasma.in/" target='_blank' rel="noreferrer">needplasma.in</a><br/>
          &rarr; &nbsp;<a href="https://plasmaline.in/" target='_blank' rel="noreferrer">plasmaline.in</a><br/>
          &rarr; &nbsp;<a href="http://friends2support.org/" target='_blank' rel="noreferrer">friends2support.org</a><br/>
          &rarr; &nbsp;<a href="https://covidplasma.online/" target='_blank' rel="noreferrer">View More Websites</a>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} className={classes.main} onChange={handleChange('panel2')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
          className={classes.body}
        >
          <Typography className={classes.heading}>Get Vaccinated</Typography>
          
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.links}>
            &rarr; &nbsp;
            <a href="https://www.cowin.gov.in/home" target='_blank' rel="noreferrer">Government of India Vaccination drive</a>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel3'} className={classes.main} onChange={handleChange('panel3')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
          className={classes.body}
        >
          <Typography className={classes.heading}>Find Covid Test Center near you</Typography>
          
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.links}>
          &rarr; &nbsp;
          <a href="https://covid.icmr.org.in/index.php/testing-facilities#30.8432782/66.6476503/4" target='_blank' rel="noreferrer">Testing Centers all over India</a>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel4'} className={classes.main} onChange={handleChange('panel4')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className={classes.body}
        >
          <Typography className={classes.heading}>Government helpdesk and helplines</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.links}>
            &rarr; &nbsp;<a href="https://api.whatsapp.com/send/?phone=919013151515&text=Hi&app_absent=0" target="_blank" rel="norefferer">WhatsApp helpdesk</a><br/>
             &rarr; &nbsp;<a href="https://t.ly/Z9I4" target="_blank" rel="norefferer">Statewise helplines</a><br/>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel5'} className={classes.main} onChange={handleChange('panel5')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className={classes.body}
        >
          <Typography className={classes.heading}>Remdesivir, Plasma donation and others</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.links}>
            &rarr; &nbsp;<a href="https://vaccineindia.org/new/admin-master/public/ckeditor/kcfinder/upload/files/Remdesivir-Distributor-List.pdf" target="_blank" rel="norefferer">Nationawide Remdesivir Suppliers</a><br/>
            &rarr; &nbsp;<a href="https://linktr.ee/COVID19support.India" target="_blank" rel="norefferer">Fridays For Future - Covid Support</a><br/>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel6'} className={classes.main} onChange={handleChange('panel6')}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel4bh-content"
          id="panel4bh-header"
          className={classes.body}
        >
          <Typography className={classes.heading}>Get Help on Twitter</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className={classes.links}>
            &rarr; &nbsp;<a href="https://www.instagram.com/reel/CN44ScdhWPx/?igshid=57vviytzn3cy" target="_blank" rel="norefferer">Twitter Search Filter for Easy access - Adnaan Khan</a><br/>
            &rarr; &nbsp;<a href="https://covid19-twitter.in/" target="_blank" rel="norefferer">Twitter tweets search for Covid resources</a><br/>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}